import { render } from "./IntegrationPurposes.vue?vue&type=template&id=551fbfc1&scoped=true"
import script from "./IntegrationPurposes.vue?vue&type=script&lang=js"
export * from "./IntegrationPurposes.vue?vue&type=script&lang=js"

import "./IntegrationPurposes.vue?vue&type=style&index=0&id=551fbfc1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551fbfc1"]])

export default __exports__